import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import JobList from './JobList';
import JobFilter from '../../Jobs/JobsTable/JobFilter';
import DtnPhotoModal from '../dtn/paritals/DtnPhotoModal';

class JobsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            offset: 0,
            status: 'all',
            filter: '',
            allusers: false,
            showOnHoldModal: false,
            currentJob: null,
            holdReason: '',
            showSummaryModal: false,
            summaryLoading: false,
            summaryJob: null,
            photoModalOpen: false,
            photoModalMedia: [],
            photoModalIndex: 0,
            photoModalTitle: '',
        };
    }

    loadJobsFromServer() {
        let data = {
            limit: this.props.perPage,
            offset: this.state.offset,
            status: this.state.status,
            filter: this.state.filter,
            allusers: this.state.allusers,
        };

        if (this.props.manager_review) {
            data = { ...data, manager_review: this.props.manager_review };
        }

        if (this.props.superadmin_review) {
            data = { ...data, superadmin_review: this.props.superadmin_review };
        }

        if (this.props.follow_on_review) {
            data = { ...data, follow_on_review: this.props.follow_on_review };
        }

        this.setState({ loading: true });
        $.ajax({
            url: this.props.url,
            data: data,
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    data: data.jobs,
                    pageCount: Math.ceil(data.total / this.props.perPage),
                    loading: false,
                });
            },

            error: (xhr, status, err) => {
                this.setState({ loading: false });
                console.log(this.props.url, status, err.toString());
            },
        });
    }

    componentDidMount() {
        this.loadJobsFromServer();

        if (this.props.success) {
            toastr.success(this.props.success);
        } else if (this.props.error) {
            toastr.error(this.props.error);
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadJobsFromServer();
        });
    };

    handleClick = (url) => {
        window.open(url, '_blank');
    };

    handleMarkCompleteClick = (job) => {
        let statusLabel;
        let data;

        const isFollowOn = job.status === 'follow-on';
        const isWastedJourney = Number(job.waste_journey) === 1 || job.status === 'wasted_journey';

        if (isFollowOn) {
            statusLabel = 'Follow on';
            data = { status: 'allocated' };
        } else if (isWastedJourney) {
            statusLabel = 'wasted journey';
            data = {
                status: 'completed',
                waste_journey: 1,
            };
        } else {
            statusLabel = 'completed';
            data = {
                status: 'completed',
            };
        }

        const hasPendingManagerReview = job.reviews?.some(
            (review) =>
                review.type === 'manager' && review.review_category === 'approval' && Number(review.approved) === 0
        );

        const hasPendingSuperadminReview = job.reviews?.some(
            (review) =>
                review.type === 'superadmin' && review.review_category === 'approval' && Number(review.approved) === 0
        );

        if (this.props.manager_review || hasPendingManagerReview) {
            data.manager_review_approve = 1;
        }

        if (this.props.superadmin_review || hasPendingSuperadminReview) {
            data.superadmin_review_approve = 1;
        }

        data.completed_via_green_tick = 1;

        window.swal
            .fire({
                title: `Mark this job as ${statusLabel}?`,
                text: `Are you sure you want to mark this job as ${statusLabel}?`,
                type: 'question',
                input: 'checkbox',
                inputPlaceholder: 'Recreate the job?',
                showCancelButton: true,
                confirmButtonText: `Mark as ${statusLabel}`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${job.id}/review`,
                    data: isConfirm.value ? { ...data, recreate: 1 } : data,
                    dataType: 'json',
                    type: 'patch',
                    success: () => {
                        location.reload();
                    },
                    error: (res) => {
                        toastr.error(res.responseJSON?.message ?? 'There was a problem, please try again later');
                    },
                });
            });
    };

    handleDelete = (job) => {
        $.get(`/jobs/${job.id}/is-invoiced`, (response) => {
            let title = `Delete job ${job.id}`;
            let text = response.invoiced
                ? 'This job has already been invoiced. Deleting it may cause accounting issues. Are you sure?'
                : 'Are you sure you want to delete this job?';

            window.swal
                .fire({
                    title: title,
                    text: text,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                })
                .then((result) => {
                    if (result.dismiss) return;

                    $.ajax({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        },
                        url: `/jobs/${job.id}`,
                        type: 'delete',
                        success: () => location.reload(),
                    });
                });
        });
    };

    handleNotifyCustomer = (job) => {
        // Both cases now show as status 'done' - a job that triggered a follow-on
        // (has its own revisit_reason) needs the follow-on flow, everything else
        // in this tab is a plain completion needing the job-done flow.
        if (!job.revisit_reason) {
            this.handleNotifyJobDone(job);
            return;
        }

        $.get(`/jobs/${job.id}/previous-follow-on-info`, (info) => {
            const previousDate = info.previous_anticipated_completion_date;
            const previousDateFormatted = previousDate ? window.moment(previousDate).format('DD/MM/YYYY') : null;

            const text = previousDate
                ? `The previous follow-on had an anticipated completion date of ${previousDateFormatted}. Confirm or update it below - it'll be included in the email to the customer.`
                : `Send the customer an email confirming their follow-on job? Pick the anticipated completion date to include in the email.`;

            window.swal
                .fire({
                    title: 'Notify customer?',
                    html: `
                        <p>${text}</p>
                        <input
                            id="swal-anticipated-date"
                            type="date"
                            class="swal2-input"
                            value="${previousDate || ''}"
                        >
                        <textarea
                            id="swal-followon-reason"
                            class="swal2-textarea"
                            placeholder="Reason for follow-on (sent to the customer if the date changes)"
                        ></textarea>
                    `,
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Send',
                    focusConfirm: false,
                    preConfirm: () => {
                        const date = document.getElementById('swal-anticipated-date').value;
                        const reason = document.getElementById('swal-followon-reason').value;

                        if (!date) {
                            window.swal.showValidationMessage('Please select an anticipated date of completion');
                            return false;
                        }

                        const dateChanged = date !== (previousDate || '');

                        if (dateChanged && !reason) {
                            window.swal.showValidationMessage(
                                'Please enter a reason for the follow-on - an email will be sent to the customer'
                            );
                            return false;
                        }

                        return { date, reason };
                    },
                })
                .then((result) => {
                    if (result.dismiss || !result.value) return;

                    $.ajax({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        },
                        url: `/jobs/${job.id}/follow-on-notify`,
                        type: 'post',
                        data: {
                            anticipated_completion_date: result.value.date,
                            follow_on_reason: result.value.reason,
                        },
                        success: (res) => {
                            toastr.success(res.message ?? 'Customer notified');
                            this.loadJobsFromServer();
                        },
                        error: (res) => {
                            toastr.error(res.responseJSON?.message ?? 'There was a problem, please try again later');
                        },
                    });
                });
        });
    };

    handleNotifyJobDone = (job) => {
        window.swal
            .fire({
                title: 'Notify customer?',
                text: `Let the customer know their waste collection (job ${job.id}) is complete? They'll be told it's now being reviewed by our team and a waste transfer note (WTN) will follow.`,
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Send',
            })
            .then((result) => {
                if (result.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${job.id}/job-done-notify`,
                    type: 'post',
                    success: (res) => {
                        toastr.success(res.message ?? 'Customer notified');
                        this.loadJobsFromServer();
                    },
                    error: (res) => {
                        toastr.error(res.responseJSON?.message ?? 'There was a problem, please try again later');
                    },
                });
            });
    };

    handleShowSummary = (job) => {
        this.setState({ showSummaryModal: true, summaryLoading: true, summaryJob: null });

        $.get(`/jobs/${job.id}/follow-on-summary`)
            .done((data) => {
                this.setState({ summaryJob: data, summaryLoading: false });
            })
            .fail(() => {
                toastr.error('Failed to load job summary');
                this.setState({ showSummaryModal: false, summaryLoading: false });
            });
    };

    closeSummaryModal = () => {
        this.setState({ showSummaryModal: false, summaryJob: null });
    };

    openPhotoModal = (media, index, title) => {
        this.setState({ photoModalOpen: true, photoModalMedia: media, photoModalIndex: index, photoModalTitle: title });
    };

    closePhotoModal = () => {
        this.setState({ photoModalOpen: false });
    };

    handleAllUsers = (value) => {
        this.setState(
            {
                allusers: value,
                offset: 0,
            },
            () => {
                this.loadJobsFromServer();
            }
        );
    };

    handleFilter = (e) => {
        this.setState({
            filter: e.target.value,
            offset: 0,
        });
    };

    handleFilterEnter = (e) => {
        if (e.key === 'Enter') {
            this.loadJobsFromServer();
        }
    };

    handleStatus = (e) => {
        this.setState(
            {
                status: e.value,
                offset: 0,
            },
            () => {
                this.loadJobsFromServer();
            }
        );
    };

    toggleOnHold = (job) => {
        this.setState({
            showOnHoldModal: true,
            currentJob: job,
            holdReason: job.review_on_hold_reason || '',
        });
    };

    handleOnHoldSubmit = (e) => {
        e.preventDefault();

        const { currentJob, holdReason } = this.state;
        const isOnHold = !!currentJob.review_on_hold;

        const url = isOnHold ? `/jobs/${currentJob.id}/remove-review-on-hold` : `/jobs/${currentJob.id}/review-on-hold`;

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            body: JSON.stringify({ reason: holdReason }),
        })
            .then((res) => {
                if (!res.ok) throw new Error();
                return res.json();
            })
            .then(() => {
                toastr.success(isOnHold ? 'Flag removed' : 'Flag added');
                this.setState({ showOnHoldModal: false }, () => {
                    this.loadJobsFromServer(); // refresh job list
                });
            })
            .catch(() => toastr.error('Failed to update flag'));
    };

    closeModal = () => {
        this.setState({ showOnHoldModal: false });
    };

    render() {
        const {
            showOnHoldModal,
            currentJob,
            holdReason,
            showSummaryModal,
            summaryLoading,
            summaryJob,
            photoModalOpen,
            photoModalMedia,
            photoModalIndex,
            photoModalTitle,
        } = this.state;
        const isOnHold = currentJob ? !!currentJob.review_on_hold : false;
        const currentReason = holdReason || '';

        // Determine button text and disabled state
        const saveBtnText = isOnHold ? 'Remove Flag' : 'Add Flag';
        const isSaveDisabled = !currentReason.trim();
        return (
            <Fragment>
                <div className="row">
                    <div className="col-12">
                        {this.props.operations ? (
                            <span className="float-right">
                                <button
                                    className={`btn btn-outline-cw-primary ${this.state.allusers ? '' : 'active'} ml-2`}
                                    onClick={() => this.handleAllUsers(false)}
                                >
                                    My Jobs
                                </button>
                                <button
                                    className={`btn btn-outline-cw-primary ${this.state.allusers ? 'active' : ''} ml-2`}
                                    onClick={() => this.handleAllUsers(true)}
                                >
                                    All Jobs
                                </button>
                            </span>
                        ) : null}
                    </div>
                </div>
                <div className="row pt-2">
                    <div className="col-12">
                        <div className="cw-bg-grey py-1 d-flex justify-content-between align-items-center">
                            <div className="flex-grow-1">
                                <h6 className="py-2 pl-2 text-white">Jobs</h6>
                            </div>
                            <input
                                type="textbox"
                                placeholder="Filter"
                                className="pr-2 py-1 w-25 mr-2"
                                value={this.state.filter}
                                onChange={this.handleFilter}
                                onKeyUp={this.handleFilterEnter}
                                name="filter"
                            />
                            {this.props.filterOptions && (
                                <div className="pr-2 w-25">
                                    <JobFilter options={this.props.filterOptions} onChange={this.handleStatus} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <JobList
                    data={this.state.data}
                    onClick={this.handleClick}
                    onDelete={this.handleDelete}
                    markComplete={this.handleMarkCompleteClick}
                    manager_review={this.props.manager_review}
                    superadmin_review={this.props.superadmin_review}
                    follow_on_review={this.props.follow_on_review}
                    notifyCustomer={this.handleNotifyCustomer}
                    showSummary={this.handleShowSummary}
                    toggleOnHold={this.toggleOnHold}
                />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
                {this.state.loading ? <div className="processing-card card">Processing...</div> : null}

                {showOnHoldModal && (
                    <div
                        className={`modal fade${showOnHoldModal ? ' show d-block' : ''}`}
                        id="jobsOnHoldModal"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="jobsOnHoldModalLabel"
                        aria-hidden={!showOnHoldModal}
                        style={{
                            backgroundColor: showOnHoldModal ? 'rgba(0,0,0,0.5)' : 'transparent',
                        }}
                    >
                        <div className="modal-dialog" role="document">
                            <form id="jobsOnHoldForm" onSubmit={this.handleOnHoldSubmit}>
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="jobsOnHoldModalLabel">
                                            Job On Hold
                                        </h5>
                                        <button
                                            type="button"
                                            className="close"
                                            aria-label="Close"
                                            onClick={this.closeModal}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <input
                                            type="hidden"
                                            id="jobId"
                                            name="jobId"
                                            value={currentJob?.id || ''}
                                            readOnly
                                        />
                                        <div className="form-group">
                                            <label htmlFor="holdReason">Reason for putting job on hold</label>
                                            <textarea
                                                className="form-control"
                                                id="holdReason"
                                                name="holdReason"
                                                required
                                                value={holdReason}
                                                onChange={(e) =>
                                                    this.setState({
                                                        holdReason: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                                            Close
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-cw-primary"
                                            id="saveHoldReasonBtn"
                                            disabled={isSaveDisabled}
                                        >
                                            {saveBtnText}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {showSummaryModal && (
                    <div
                        className="modal fade show d-block"
                        id="followOnSummaryModal"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="followOnSummaryModalLabel"
                        style={{ backgroundColor: 'rgba(0,0,0,0.5)', overflowY: 'auto' }}
                    >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="followOnSummaryModalLabel">
                                        Customer update summary
                                    </h5>
                                    <button
                                        type="button"
                                        className="close"
                                        aria-label="Close"
                                        onClick={this.closeSummaryModal}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {summaryLoading && <p>Loading...</p>}

                                    {!summaryLoading && summaryJob && (
                                        <Fragment>
                                            <p>
                                                <strong>Job ID:</strong>{' '}
                                                <a
                                                    href={`/jobs/${summaryJob.id}${
                                                        summaryJob.status === 'done' ? '/dtn/edit' : ''
                                                    }`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {summaryJob.id}
                                                </a>
                                            </p>
                                            <p>
                                                <strong>Address:</strong> {summaryJob.address_line_1}
                                                {summaryJob.address_line_2 ? `, ${summaryJob.address_line_2}` : ''}
                                                {summaryJob.city ? `, ${summaryJob.city}` : ''}
                                                {summaryJob.postcode ? `, ${summaryJob.postcode}` : ''}
                                            </p>
                                            <p>
                                                <strong>Customer:</strong> {summaryJob.customer?.name || 'N/A'}
                                            </p>
                                            <p>
                                                <strong>Customer contact:</strong>{' '}
                                                {summaryJob.customer_contact
                                                    ? `${summaryJob.customer_contact.name} (${
                                                          summaryJob.customer_contact.email || 'no email'
                                                      }, ${summaryJob.customer_contact.telephone || 'no phone'})`
                                                    : 'N/A'}
                                            </p>
                                            {summaryJob.revisit_reason && (
                                                <p>
                                                    <strong>Reason for revisit:</strong> {summaryJob.revisit_reason}
                                                    {summaryJob.revisit_reason_note
                                                        ? ` — ${summaryJob.revisit_reason_note}`
                                                        : ''}
                                                </p>
                                            )}
                                            <p>
                                                <strong>
                                                    {summaryJob.status === 'follow-on' ? 'Follow-on created:' : 'Job completed:'}
                                                </strong>{' '}
                                                {summaryJob.created_at
                                                    ? window.moment(summaryJob.created_at).format('DD/MM/YYYY HH:mm')
                                                    : 'N/A'}
                                            </p>
                                            {summaryJob.follow_on_notified_at && (
                                                <p>
                                                    <strong>Follow-on notified:</strong>{' '}
                                                    {window
                                                        .moment(summaryJob.follow_on_notified_at)
                                                        .format('DD/MM/YYYY HH:mm')}{' '}
                                                    by {summaryJob.follow_on_notified_by || 'unknown'}
                                                </p>
                                            )}
                                            {summaryJob.completion_notified_at && (
                                                <p>
                                                    <strong>Completion notified:</strong>{' '}
                                                    {window
                                                        .moment(summaryJob.completion_notified_at)
                                                        .format('DD/MM/YYYY HH:mm')}{' '}
                                                    by {summaryJob.completion_notified_by || 'unknown'}
                                                </p>
                                            )}

                                            {summaryJob.estimated_hours && (
                                                <p>
                                                    <strong>Estimated hours to complete:</strong>{' '}
                                                    {summaryJob.estimated_hours >= 13
                                                        ? '12+ hours'
                                                        : `${summaryJob.estimated_hours} hour${
                                                              summaryJob.estimated_hours === 1 ? '' : 's'
                                                          }`}
                                                </p>
                                            )}

                                            {summaryJob.waste_volume_left_cy && (
                                                <p>
                                                    <strong>Volume of waste left:</strong>{' '}
                                                    {summaryJob.waste_volume_left_cy} cy
                                                </p>
                                            )}

                                            {summaryJob.waste_weight_left_kg && (
                                                <p>
                                                    <strong>Estimated weight of waste left:</strong>{' '}
                                                    {summaryJob.waste_weight_left_kg} kg
                                                </p>
                                            )}

                                            {summaryJob.revisit_photos.length > 0 && (
                                                <Fragment>
                                                    <div className="bg-secondary text-white px-2 py-1 rounded mb-2">
                                                        <strong>Revisit reason photos</strong>
                                                    </div>
                                                    <div className="mb-3">
                                                        <div className="row">
                                                            {summaryJob.revisit_photos.map((image, index) => (
                                                                <div className="col-4 mb-2" key={image.id}>
                                                                    <img
                                                                        src={image.url}
                                                                        alt="Revisit reason"
                                                                        className="img-fluid"
                                                                        style={{ cursor: 'zoom-in' }}
                                                                        onClick={() =>
                                                                            this.openPhotoModal(
                                                                                summaryJob.revisit_photos,
                                                                                index,
                                                                                'Revisit reason photos'
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            )}

                                            {summaryJob.images_before.length > 0 && (
                                                <Fragment>
                                                    <div className="bg-secondary text-white px-2 py-1 rounded mb-2">
                                                        <strong>Before photos</strong>
                                                    </div>
                                                    <div className="mb-3">
                                                        <div className="row">
                                                            {summaryJob.images_before.map((image, index) => (
                                                                <div className="col-4 mb-2" key={image.id}>
                                                                    <img
                                                                        src={image.url}
                                                                        alt="Before"
                                                                        className="img-fluid"
                                                                        style={{ cursor: 'zoom-in' }}
                                                                        onClick={() =>
                                                                            this.openPhotoModal(
                                                                                summaryJob.images_before,
                                                                                index,
                                                                                'Before photos'
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            )}

                                            {summaryJob.images_after.length > 0 && (
                                                <Fragment>
                                                    <div className="bg-secondary text-white px-2 py-1 rounded mb-2">
                                                        <strong>After photos</strong>
                                                    </div>
                                                    <div className="mb-3">
                                                        <div className="row">
                                                            {summaryJob.images_after.map((image, index) => (
                                                                <div className="col-4 mb-2" key={image.id}>
                                                                    <img
                                                                        src={image.url}
                                                                        alt="After"
                                                                        className="img-fluid"
                                                                        style={{ cursor: 'zoom-in' }}
                                                                        onClick={() =>
                                                                            this.openPhotoModal(
                                                                                summaryJob.images_after,
                                                                                index,
                                                                                'After photos'
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            )}

                                            {summaryJob.previous_jobs.length > 0 && (
                                                <Fragment>
                                                    {summaryJob.previous_jobs.length > 1 && (
                                                        <p>
                                                            <strong>Other previous jobs:</strong>{' '}
                                                            {summaryJob.previous_jobs.slice(0, -1).map((previousJob, i, arr) => (
                                                                <Fragment key={previousJob.id}>
                                                                    <a
                                                                        href={`/jobs/${previousJob.id}`}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        Job {previousJob.id}
                                                                    </a>
                                                                    {i < arr.length - 1 ? ', ' : ''}
                                                                </Fragment>
                                                            ))}
                                                        </p>
                                                    )}

                                                    {(() => {
                                                        const originatingJob =
                                                            summaryJob.previous_jobs[summaryJob.previous_jobs.length - 1];

                                                        return (
                                                            <Fragment>
                                                                {originatingJob.images_before.length > 0 && (
                                                                    <Fragment>
                                                                        <div className="bg-secondary text-white px-2 py-1 rounded mb-2">
                                                                            <strong>Previous job - Before photos</strong>
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <div className="row">
                                                                                {originatingJob.images_before.map(
                                                                                    (image, index) => (
                                                                                        <div
                                                                                            className="col-4 mb-2"
                                                                                            key={image.id}
                                                                                        >
                                                                                            <img
                                                                                                src={image.url}
                                                                                                alt="Previous job before"
                                                                                                className="img-fluid"
                                                                                                style={{
                                                                                                    cursor: 'zoom-in',
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    this.openPhotoModal(
                                                                                                        originatingJob.images_before,
                                                                                                        index,
                                                                                                        'Previous job - Before photos'
                                                                                                    )
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    )
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </Fragment>
                                                                )}

                                                                {originatingJob.images_after.length > 0 && (
                                                                    <Fragment>
                                                                        <div className="bg-secondary text-white px-2 py-1 rounded mb-2">
                                                                            <strong>Previous job - After photos</strong>
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <div className="row">
                                                                                {originatingJob.images_after.map(
                                                                                    (image, index) => (
                                                                                        <div
                                                                                            className="col-4 mb-2"
                                                                                            key={image.id}
                                                                                        >
                                                                                            <img
                                                                                                src={image.url}
                                                                                                alt="Previous job after"
                                                                                                className="img-fluid"
                                                                                                style={{
                                                                                                    cursor: 'zoom-in',
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    this.openPhotoModal(
                                                                                                        originatingJob.images_after,
                                                                                                        index,
                                                                                                        'Previous job - After photos'
                                                                                                    )
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                    )
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </Fragment>
                                                                )}
                                                            </Fragment>
                                                        );
                                                    })()}
                                                </Fragment>
                                            )}
                                        </Fragment>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={this.closeSummaryModal}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {photoModalOpen && (
                    <DtnPhotoModal
                        media={photoModalMedia}
                        index={photoModalIndex}
                        title={photoModalTitle}
                        onClose={this.closePhotoModal}
                    />
                )}
            </Fragment>
        );
    }
}

if (document.getElementById('jobs-table')) {
    let element = document.getElementById('jobs-table');
    let filterOptions = element.dataset.filter ? element.dataset.filter : 0;
    ReactDOM.render(
        <JobsTable
            url={element.dataset.url}
            perPage={10}
            filterOptions={filterOptions ? JSON.parse(element.dataset.filter) : null}
            success={element.dataset.success}
            error={element.dataset.error}
            manager_review={element.dataset.manager_review}
            superadmin_review={element.dataset.superadmin_review}
            follow_on_review={element.dataset.follow_on_review}
            operations={element.dataset.operations}
        />,
        element
    );
}

export default JobsTable;
